import React from 'react';
import styles from './styles.module.scss';

const WarningBanner = () => {
  
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        
        <div className={styles.iconWrapper}>
          <svg 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </div>

        <div className={styles.content}>
          <h2>Access Restricted</h2>
          <p className={styles.primaryMsg}>
            Warning: Please use Safe Exam Browser to access this application.
          </p>
          <p className={styles.secondaryMsg}>
            This application is designed to be used within the Safe Exam Browser 
            environment to ensure security and integrity during exams.
          </p>
          
          <button className={styles.retryBtn} onClick={handleReload}>
            Reload Application
          </button>
        </div>
        
      </div>
    </div>
  );
};

export default WarningBanner;